/** Devices card: per-type device counts and the total (E2.1 spec 7.2/7.6). Pencil opens the devices edit face. */
import type { ShopSummary } from '../../api/types.ts';
import { deviceCountTotal } from './deviceCountHelpers.ts';
import { DetailRow } from './DetailRow.tsx';
import { EditableCard } from './EditableCard.tsx';

export interface ShopDevicesCardProps {
  shop: ShopSummary;
  canWrite: boolean;
  onSaved: () => void;
}

export function ShopDevicesCard({ shop, canWrite, onSaved }: Readonly<ShopDevicesCardProps>): React.JSX.Element {
  return (
    <EditableCard title="Devices" group="devices" shop={shop} canWrite={canWrite} onSaved={onSaved}>
      <DetailRow label="Admin devices" value={String(shop.device_count_admin)} />
      <DetailRow label="Teller devices" value={String(shop.device_count_teller)} />
      <DetailRow label="Payout devices" value={String(shop.device_count_payout)} />
      <DetailRow label="Total devices" value={String(deviceCountTotal(shop))} />
    </EditableCard>
  );
}

export default ShopDevicesCard;
